import { lazy } from "react";

export const Home = lazy(() => import("@/pages/AppHome"));

export const AppSignUp = lazy(() => import("@/pages/AppSignUp"));
export const AppSignUpCodeConfirmation = lazy(
  () => import("@/pages/AppSignUpConfirmation")
);
export const AppSignUpCheckbox = lazy(
  () => import("@/pages/AppSignUpCheckbox")
);
export const AppSignUpProject = lazy(() => import("@/pages/AppSignUpProject"));

export const AppAuditManagement = lazy(
  () => import("@/pages/AppAuditManagement")
);
export const AppAuditManagementList = lazy(
  () => import("@/pages/AppAuditManagementList")
);
export const AppAuditManagementExport = lazy(
  () => import("@/pages/AppAuditManagementExport")
);
export const AppAuditManagementDetailV2 = lazy(
  () => import("@/pages/AppAuditManagementDetailV2")
);
export const AppPollUpdate = lazy(() => import("@/pages/AppPollUpdate"));
export const AppCategoryPollList = lazy(
  () => import("@/pages/AppCategoryPollList")
);
export const AppSettings = lazy(() => import("@/pages/AppSettings"));
export const AppAuditCenter = lazy(() => import("@/pages/AppAuditCenter"));
export const AppSettingsInventory = lazy(
  () => import("@/pages/AppSettingsInventory")
);
export const AppSettingsOthers = lazy(
  () => import("@/pages/AppSettingsOthers")
);
export const AppTrackerTemplates = lazy(
  () => import("@/pages/AppTrackerTemplates")
);
export const AppSettingsDocumentTypes = lazy(
  () => import("@/pages/AppDocumentTypes")
);
export const AppSettingsCompany = lazy(
  () => import("@/pages/AppSettingsCompany")
);
export const AppSettingsNotifications = lazy(
  () => import("@/pages/AppSettingsNotifications")
);
export const AppSettingsPhotoQuality = lazy(
  () => import("@/pages/AppSettingsPhotoQuality")
);
export const AppSettingsUnplannedWO = lazy(
  () => import("@/pages/AppSettingsUnplannedWO")
);
export const AppSettingsApprovalFlows = lazy(
  () => import("@/pages/AppSettingsApprovalFlows")
);
export const AppWorkOrderApprovals = lazy(
  () => import("@/pages/AppWorkOrderApprovals")
);
export const AppSerialConflict = lazy(
  () => import("@/pages/AppSerialConflict")
);
export const AppSettingsMap = lazy(() => import("@/pages/AppSettingsMap"));
export const AppSchedulerRoot = lazy(() => import("@/pages/AppSchedulerRoot"));
export const AppScheduler = lazy(() => import("@/pages/AppScheduler"));
export const AppSchedulerTechnicians = lazy(
  () => import("@/pages/AppSchedulerTechnicians")
);
export const AppPollDelete = lazy(() => import("@/pages/AppPollDelete"));
export const AppCategoryPollNew = lazy(
  () => import("@/pages/AppCategoryPollNew")
);
export const AppCategoryPollUpdate = lazy(
  () => import("@/pages/AppCategoryPollUpdate")
);
export const AppCategoryPollDelete = lazy(
  () => import("@/pages/AppCategoryPollDelete")
);
export const AppPollBuilderV2 = lazy(() => import("@/pages/AppPollBuilderV2"));
export const AppPollImport = lazy(() => import("@/pages/AppPollImport"));
export const AppProjectManagement = lazy(
  () => import("@/pages/AppProjectManagement")
);
export const AppAuditManagementAnswerUpdate = lazy(
  () => import("@/pages/AppAuditManagementAnswerUpdate")
);
export const AppAuditManagementEntries = lazy(
  () => import("@/pages/AppAuditManagementEntries")
);
export const AppReportTemplateManagement = lazy(
  () =>
    import("@/pages/AppReportTemplateManagement/AppReportTemplateManagement")
);
export const AppInboxManagementList = lazy(
  () => import("@/pages/AppInboxManagementList")
);
export const AppDashboardTemplate = lazy(
  () => import("@/pages/AppDashboardTemplate")
);
export const AppLayoutDashboardManagement = lazy(
  () => import("@/pages/AppLayoutDashboardManagement")
);
export const AppLayoutDashboardUpdate = lazy(
  () => import("@/pages/AppLayoutDashboardUpdate")
);
export const AppLayoutDashboardNew = lazy(
  () => import("@/pages/AppLayoutDashboardNew")
);
export const AppLayoutDashboardDelete = lazy(
  () => import("@/pages/AppLayoutDashboardDelete")
);
export const AppUserManagement = lazy(
  () => import("@/pages/AppUserManagement")
);
export const AppUserManagementNew = lazy(
  () => import("@/pages/AppUserManagementNew")
);
export const AppUserManagementUpdate = lazy(
  () => import("@/pages/AppUserManagementUpdate")
);
export const AppUserManagementChangePassword = lazy(
  () => import("@/pages/AppUserManagementChangePassword")
);
export const AppUserManagementDelete = lazy(
  () => import("@/pages/AppUserManagementDelete")
);
export const AppUserManagementActivity = lazy(
  () => import("@/pages/AppUserManagementActivity")
);
export const AppUserProfileHome = lazy(
  () => import("@/pages/AppUserProfileHome")
);
export const AppUserProfile = lazy(() => import("@/pages/AppUserProfile"));
export const AppNotificationsPreferences = lazy(
  () => import("@/pages/AppNotificationsPreferences")
);
export const AppPermissionProfileManagement = lazy(
  () => import("@/pages/AppPermissionProfileManagement")
);
export const AppPermissionProfile = lazy(
  () => import("@/pages/AppPermissionProfile")
);
export const AppUserManagementCompany = lazy(
  () => import("@/pages/AppVendorManagement")
);
export const AppUserManagementCompanyNew = lazy(
  () => import("@/pages/AppUserManagementCompanyNew")
);
export const AppUserManagementCompanyUpdate = lazy(
  () => import("@/pages/AppUserManagementCompanyUpdate")
);
export const AppUserManagementCompanyDelete = lazy(
  () => import("@/pages/AppUserManagementCompanyDelete")
);
export const AppUserManagementBusiness = lazy(
  () => import("@/pages/AppUserManagementBusiness")
);
export const AppUserManagementBusinessNew = lazy(
  () => import("@/pages/AppUserManagementBusinessNew")
);
export const AppUserManagementBusinessUpdate = lazy(
  () => import("@/pages/AppUserManagementBusinessUpdate")
);
export const AppUserManagementBusinessDelete = lazy(
  () => import("@/pages/AppUserManagementBusinessDelete")
);
export const AppUserManagementSecurity = lazy(
  () => import("@/pages/AppUserManagementSecurity")
);
export const AppEquipmentManagement = lazy(
  () => import("@/pages/AppEquipmentManagement")
);
export const AppEquipmentManagementStockControl = lazy(
  () => import("@/pages/AppEquipmentManagementStockControl")
);
export const AppInventory = lazy(() => import("@/pages/AppInventory"));

export const AppPageTest = lazy(() => import("@/pages/PageTest"));

export const AppDashboardEmpty = lazy(() => import("@/pages/AppDashboardNew"));

export const AppDashboardNew = lazy(() => import("@/pages/AppDashboardNew"));

export const AppDriveTestControl = lazy(
  () => import("@/pages/AppDriveTestControl")
);

export const AppDriveTestControlDashboard = lazy(
  () => import("@/pages/AppDriveTestControlDashboard")
);

export const AppDriveTestControlSettings = lazy(
  () => import("@/pages/AppDriveTestControlSettings")
);
export const AppDriveTestControlNew = lazy(
  () => import("@/pages/AppDriveTestControlNew")
);
export const AppDriveTestControlUpdate = lazy(
  () => import("@/pages/AppDriveTestControlUpdate")
);
export const AppDriveTestControlCollectionCycleNew = lazy(
  () => import("@/pages/AppDriveTestControlCollectionCycleNew")
);
export const AppDriveTestControlCollectionCycleUpdate = lazy(
  () => import("@/pages/AppDriveTestControlCollectionCycleUpdate")
);
export const AppAuditManagementAnswerNew = lazy(
  () => import("@/pages/AppAuditManagementAnswerNew")
);
export const AppAuditManagementDashboard = lazy(
  () => import("@/pages/AppAuditManagementDashboard")
);

export const AppSiteVisits = lazy(() => import("@/pages/AppSiteVisits"));
export const AppSiteVisitsDashboard = lazy(
  () => import("@/pages/AppSiteVisitsDashboard")
);
export const AppSiteVisitsWorkInProgress = lazy(
  () => import("@/pages/AppSiteVisitsWorkInProgress")
);
export const AppSiteVisitsDetails = lazy(
  () => import("@/pages/AppSiteVisitsDetails")
);

export const AppSiteVisitsLive = lazy(
  () => import("@/pages/AppSiteVisitsLive")
);
export const AppSiteVisitsLiveView = lazy(
  () => import("@/pages/AppSiteVisitsLiveView")
);
export const AppSiteVisitsGroupRealtimeNew = lazy(
  () => import("@/pages/AppSiteVisitsGroupRealTimeNew")
);

export const AppSiteVisitsGroupRealtimeUpdate = lazy(
  () => import("@/pages/AppSiteVisitsGroupRealtimeUpdate")
);
export const AppAuditManagementExternalData = lazy(
  () => import("@/pages/AppAuditManagementExternalData")
);
export const AppExternalDataRows = lazy(
  () => import("@/pages/AppExternalDataRows")
);
export const AppPollAnswerDelete = lazy(
  () => import("@/pages/AppPollAnswerDelete")
);
export const AppNetworkElement = lazy(
  () => import("@/pages/AppNetworkElement")
);
export const AppNetworkElementList = lazy(
  () => import("@/pages/AppNetworkElementList")
);
export const AppNetworkElementFormBegin = lazy(
  () => import("@/pages/AppNetworkElementFormBegin")
);
export const AppNetworkElementFormFinish = lazy(
  () => import("@/pages/AppNetworkElementFormFinish")
);

export const AppNetworkElementFormSystem = lazy(
  () => import("@/pages/AppNetworkElementFormSystemCards")
);
export const AppNetworkElementFormModules = lazy(
  () => import("@/pages/AppNetworkElementFormModules")
);
export const AppFormManagementAllForm = lazy(
  () => import("@/pages/AppFormManagementAllForms")
);
export const AppFormManagementCategories = lazy(
  () => import("@/pages/AppFormManagementCategories")
);

export const AppFormManagementTeams = lazy(
  () => import("@/pages/AppFormManagementTeams")
);

export const AppEntityDetail = lazy(() => import("@/pages/AppEntityDetail"));
export const AppAssetPhotoGallery = lazy(
  () => import("@/pages/AppAssetPhotoGallery")
);
export const AppNewPageBuilder = lazy(
  () => import("@/pages/AppNewPageBuilder")
);
export const AppNetworkFormBuilder = lazy(
  () => import("@/pages/AppNetworkFormBuilder")
);
export const AppNetworkForm = lazy(() => import("@/pages/AppEntityForm"));
export const AppNewNetworkElementList = lazy(
  () => import("@/pages/AppNewNetworkList")
);
export const AppNewModelsList = lazy(() => import("@/pages/AppNewModelsList"));
export const AppWorkOrder = lazy(() => import("@/pages/AppWorkOrder"));
export const AppProjects = lazy(() => import("@/pages/AppProjects"));
export const AppProjectsCreate = lazy(
  () => import("@/pages/AppProjectsCreate")
);
export const AppProjectsDetail = lazy(
  () => import("@/pages/AppProjectsDetail")
);
export const AppDocuments = lazy(() => import("@/pages/AppDocuments"));
export const AppTimesheets = lazy(() => import("@/pages/AppTimesheets"));
export const AppTimesheetsKiosk = lazy(
  () => import("@/pages/AppTimesheetsKiosk")
);
export const AppSettingsTimesheets = lazy(
  () => import("@/pages/AppSettingsTimesheets")
);
export const AppAssetItemsList = lazy(
  () => import("@/pages/AppAssetsItemList")
);
export const AppTeamsManagement = lazy(
  () => import("@/pages/AppTeamsManagement")
);
export const AppPictureManagement = lazy(
  () => import("@/pages/AppPictureManagement")
);
export const AppTemplateBuilder = lazy(
  () => import("@/pages/AppTemplateBuilder")
);
export const AppRunMediaChecklist = lazy(
  () => import("@/pages/AppRunMediaChecklist/index")
);
export const AppAuditManagementForms = lazy(
  () => import("@/pages/AppAuditManagementForms")
);
export const AppAuditManagementResponse = lazy(
  () => import("@/pages/AppAuditManagementResponse")
);
export const AppAuditManagementMap = lazy(
  () => import("@/pages/AppAuditManagementMap")
);
export const AppMessageNotification = lazy(
  () => import("@/pages/AppMessageNotification")
);
export const AppSettingsHome = lazy(() => import("@/pages/AppSettingsHome"));
export const AppSettingsScheduler = lazy(
  () => import("@/pages/AppSettingsScheduler")
);
export const AppWorkOrderTemplates = lazy(
  () => import("@/pages/AppWorkOrderTemplates")
);
export const AppOperationsOverview = lazy(
  () => import("@/pages/AppOperationsOverview")
);
export const AppAssetSearch = lazy(() => import("@/pages/AppAssetSearch"));
export const AppFormAnalysis = lazy(() => import("@/pages/AppFormAnalysis"));
export const AppSettingsFrequentWorkItems = lazy(
  () => import("@/pages/AppSettingsFrequentWorkItems")
);
export const AppSettingsJobType = lazy(
  () => import("@/pages/AppSettingsJobType")
);
export const AppSettingsJobTypeTasks = lazy(
  () => import("@/pages/AppSettingsJobTypeTasks")
);
export const AppSettingsJobTypeCustomFields = lazy(
  () => import("@/pages/AppSettingsJobTypeCustomFields")
);
export const AppSettingsMaintenance = lazy(
  () => import("@/pages/AppSettingsMaintenance")
);
export const AppBulkOperations = lazy(
  () => import("@/pages/AppBulkOperations")
);
export const AppBulkOperationsDashboard = lazy(
  () => import("@/pages/AppBulkOperationsDashboard")
);
export const AppBulkOperationsProcess = lazy(
  () => import("@/pages/AppBulkOperationsProcess")
);
export const AppBulkOperationsNew = lazy(
  () => import("@/pages/AppBulkOperationsNew")
);
export const AppMaintenance = lazy(() => import("@/pages/AppMaintenance"));
export const AppSettingsDemoData = lazy(
  () => import("@/pages/AppSettingsDemoData")
);
export const AppAuditManagementDraft = lazy(
  () => import("@/pages/AppAuditManagementDraft")
);
export const AppLibrary = lazy(() => import("@/pages/AppLibrary"));

export const AppLibraryTemplates = lazy(
  () => import("@/pages/AppLibrary/templates")
);
export const AppLibrarySchemas = lazy(
  () => import("@/pages/AppLibrary/schemas")
);
export const AppLibraryMediaTemplates = lazy(
  () => import("@/pages/AppLibrary/media_templates")
);
